import { render, staticRenderFns } from "./instagramFeed.vue?vue&type=template&id=5e3a6ead&"
import script from "./instagramFeed.vue?vue&type=script&lang=js&"
export * from "./instagramFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports